module.exports = __webpack_public_path__ + "icon_arrow_triangle_50_white.3dc88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_arrow_triangle_50_white.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_arrow_triangle_50_white.svg
// module chunks = main